<ng-template ngFor let-menuObj [ngForOf]="menuObjects">
  <button mat-menu-item disabled>
    <span>{{ menuObj.sectionTitle }}</span>
  </button>
  <mat-divider></mat-divider>
  <ng-template ngFor let-menuItems [ngForOf]="menuObj.section">
    <ng-container *ngIf="['displayOptions', 'tableOptions', 'view'].includes(menuObj.sectionId)">
      <button mat-menu-item (click)="changeListView(menuItems.selectedViewType || 'individual')" [ngClass]="{ selected: selectedViewType === menuItems.selectedViewType }">
        <mat-icon class="material-icons-outlined" *ngIf="menuItems.menuIcon">{{ menuItems.menuIcon }}</mat-icon>
        <mat-icon class="material-icons-outlined" [ngClass]="menuItems.iconClass" [svgIcon]="menuItems.svgIcon" *ngIf="menuItems.svgIcon"></mat-icon>
        <span>{{ menuItems.menuTitle }}</span>
      </button>
    </ng-container>
    <ng-container *ngIf="['sortBy', 'timePeriod'].includes(menuObj.sectionId)">
      <button
        mat-menu-item
        [disabled]="menuItems.disable"
        (click)="changeListView(menuItems['selectedViewSection2'])"
        [ngClass]="{ selected: selectedViewSection2 === menuItems['selectedViewSection2'] }"
      >
        <mat-icon class="material-icons-outlined" *ngIf="menuItems.menuIcon">{{ menuItems.menuIcon }}</mat-icon>
        <mat-icon class="material-icons-outlined" [ngClass]="menuItems.iconClass" [svgIcon]="menuItems.svgIcon" *ngIf="menuItems.svgIcon"></mat-icon>
        <span>{{ menuItems.menuTitle }}</span>
      </button>
    </ng-container>
  </ng-template>
</ng-template>
